import {
  AdminMiningCalcRequest,
  IAdminMiningCalcResponse,
} from "@services/adminMining";
import { IAdminMinerProof, IMiningPlanOptions } from "@services/getMinerList";
import { RootState } from "@store";
import useApiRequests from "@services/http/useApiRequest";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectedMinersString } from "@store/minersSelect/actionTypes";
import { useMinerContext } from "@components/Pages/Machines/MinerRow/MinerContext";

interface IAdminMiningTableControl {
  readonly table?: IAdminMinerProof[];
  readonly loading: boolean;
}

interface IAdminMiningTableProps {
  percent?: number;
  adminMining?: IAdminMinerProof[];
  miner_plan?: IMiningPlanOptions;
}

export const useAdminMiningTableControl = (
  props: IAdminMiningTableProps,
  minerID?: number
): IAdminMiningTableControl => {
  const { percent, adminMining, miner_plan } = props;
  const requests = useApiRequests();
  const { miner } = useMinerContext();
  const [table, setTable] = useState<IAdminMinerProof[] | undefined>(
    adminMining
  );
  const [lastPlan, setLastPlan] = useState<IMiningPlanOptions | undefined>(
    miner_plan
  );
  const [loading, setLoading] = useState<boolean>(true);
  const selectedMiners = useSelector((state: RootState) => state.minersSelect);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!!adminMining && adminMining.length > 0) setLoading(false);
  }, [adminMining, percent, selectedMiners]);

  const calcTable = async () => {
    if (!percent) return;

    const req = minerID
      ? new AdminMiningCalcRequest(minerID.toString(), percent)
      : new AdminMiningCalcRequest(
          selectedMinersString(selectedMiners),
          percent,
          selectedMiners.params?.filter
        );
    const response = await requests.enqueue<IAdminMiningCalcResponse>(req);
    setLoading(false);
    if (!response) return;
    setTable(response.Record);
    setLastPlan(miner_plan);
  };

  // useEffect(() => {
  //   if (!percent) return;
  //   if (percent !== lastPersent) setLastPercent(percent);
  // }, [percent]);

  useEffect(() => {
    if (
      miner.proof === percent &&
      miner_plan &&
      lastPlan &&
      miner_plan.id === lastPlan.id
    ) {
      return;
    }
    const t = setTimeout(calcTable, 1000);

    return () => clearTimeout(t);
  }, [percent, miner_plan, selectedMiners]);

  return {
    table,
    loading: loading || requests.isLoading,
  };
};
